import { call, put, select, takeLatest } from 'redux-saga/effects';
import { getErrorMessageFromAPI } from '../../utilz';
import {
  getShipmentPreBookingInfoListInSuccess,
  getShipmentPreBookingInfoListListInFail,
} from './POShipmentPreBookingSearchActions';
import { getShipmentPreBookingInfoService } from './POShipmentPreBookingSearchEffects';
import POShipmentPreBookingSearchType from './POShipmentPreBookingSearchTypes';

function* getShipmentPreBookingInfoAction() {
  try {
    const { shipmentInfoListReq } = yield select((state) => state.poShipmentPreBookingSearch);

    const { data } = yield call(getShipmentPreBookingInfoService, shipmentInfoListReq);

    yield put(getShipmentPreBookingInfoListInSuccess({ data: data }));
  } catch (e) {
    yield put(getShipmentPreBookingInfoListListInFail({ message: getErrorMessageFromAPI(e) }));
  }
}

export default function* POShipmentPreBookingSearchSaga() {
  yield takeLatest(POShipmentPreBookingSearchType.GET_SHIPMENT_PRE_BOOKING_INFO_LIST, getShipmentPreBookingInfoAction);
}
